<template>
  <div>
    <ul :class="items.length > 3 ? 'totales-list' : 'totales-simple-list'">
      <li v-for="(item, index) in items" :key="index" :class="items.length > 3 ? 'totales-item' : 'totales-item totales-simple-item'">
        <div v-if="item.value">
          <card :declaration="{
            class: getCardClassByIterationIndex(index),
            count: item.value,
            title: item.text,
            icon: 'fa-chalkboard',
          }"/>
        </div>
        <template v-else>
          <div class="total-con-grafico">
            <div class="total-con-grafico__title" style="padding: 0 5px !important; ; line-height: 0;">
              {{ item.text }}
            </div>
            <div v-if="item.graficoTorta" style="margin-top: -10px;">
              <template >
                <div>
                  <grafico-dona
                    :items="item.graficoTorta"
                  />
                </div>
              </template>
            </div>
          </div>
        </template>

        <div v-if="item.lista">
          <div class="totales-item__lista-item" v-for="(text, scIndex) in item.lista" :key="scIndex">
            <SmallCard :title="text" :className="getCardClassByIterationIndex(index)"/>
          </div>
      </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Card from '../../DasboardReportNMV/Card.vue';
import SmallCard from '../../DasboardReportNMV/SmallCard.vue';
import GraficoCircular from "./generic/GraficoCircular.vue";
import GraficoDona from './generic/GraficoDona.vue';
export default {
  components: { GraficoCircular, Card, SmallCard, GraficoDona, },
  props: {
    items: Array,
  },
  data() {
    return {
      //
    };
  },
  methods: {
    getCardClassByIterationIndex(num) {
      const classes = ['box-1', 'box-2', 'box-3', 'box-4'];
      const index = num % 4;
      return classes[index];
    }
  },
};
</script>

<style>
.totales-title {
  font-size: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}

.totales-list {
  list-style: none;
  padding-left: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  row-gap: 80px;
  column-gap: 20px;
}

.totales-item {
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: bold;
}

.total-con-grafico {
    /* position: relative; */
}

.total-con-grafico__title {
    /* position: absolute;
    transform: translatey(-100%); */
    font-size: 12px;
    text-align: center;
    margin-bottom: 10px;
}

.totales-simple-list {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
}

.totales-simple-item {
    max-width: 350px;
    width: 100%;      
}

.totales-simple-item .total-con-grafico__title {
    position: static;
    transform: none;    
}

.totales-item__lista-item {
    margin-bottom: 1px;
    padding: 0;
}
</style>